// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-body {
    display: grid;
    place-content: center;
    min-height: 100vh;
    background: #1d1f20;
    font-size: 4rem;
}

.typewriter h1 {
    color: green;
    font-family: monospace;
    overflow: hidden;
    /* Ensures the content is not revealed until the animation */
    border-right: .15em solid orange;
    /* The typwriter cursor */
    white-space: nowrap;
    /* Keeps the content on a single line */
    margin: 0 auto;
    /* Gives that scrolling effect as the typing happens */
    letter-spacing: .15em;
    /* Adjust as needed */
    animation:
        typing 3.5s steps(30, end),
        blink-caret .5s step-end infinite;
}

/* The typing effect */
@keyframes typing {
    from {
        width: 0
    }

    to {
        width: 100%
    }
}

/* The typewriter cursor effect */
@keyframes blink-caret {

    from,
    to {
        border-color: transparent
    }

    50% {
        border-color: white;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Landing.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,4DAA4D;IAC5D,gCAAgC;IAChC,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;IACd,sDAAsD;IACtD,qBAAqB;IACrB,qBAAqB;IACrB;;yCAEqC;AACzC;;AAEA,sBAAsB;AACtB;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA,iCAAiC;AACjC;;IAEI;;QAEI;IACJ;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".landing-body {\n    display: grid;\n    place-content: center;\n    min-height: 100vh;\n    background: #1d1f20;\n    font-size: 4rem;\n}\n\n.typewriter h1 {\n    color: green;\n    font-family: monospace;\n    overflow: hidden;\n    /* Ensures the content is not revealed until the animation */\n    border-right: .15em solid orange;\n    /* The typwriter cursor */\n    white-space: nowrap;\n    /* Keeps the content on a single line */\n    margin: 0 auto;\n    /* Gives that scrolling effect as the typing happens */\n    letter-spacing: .15em;\n    /* Adjust as needed */\n    animation:\n        typing 3.5s steps(30, end),\n        blink-caret .5s step-end infinite;\n}\n\n/* The typing effect */\n@keyframes typing {\n    from {\n        width: 0\n    }\n\n    to {\n        width: 100%\n    }\n}\n\n/* The typewriter cursor effect */\n@keyframes blink-caret {\n\n    from,\n    to {\n        border-color: transparent\n    }\n\n    50% {\n        border-color: white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
